import {useMutation} from '@tanstack/react-query';
import axios from 'axios';
import {toast} from '@ui/toast/toast';
import {message} from '@ui/i18n/message';
import {useNavigate} from '../../ui/navigation/use-navigate';
import {apiClient} from '../../http/query-client';

export interface ForgotPhoneNumberVerifyMobileOtpPayload {
  email: string;
  code: string;
  mobile_number: string;
  mobile_code: string;
}

export function useForgotPhoneNumberVerifyMobileOtp() {
  const navigate = useNavigate();
  return useMutation({
    mutationFn: (payload: ForgotPhoneNumberVerifyMobileOtpPayload) =>
      verifyMobileOtp(payload),
    onSuccess: () => {
      toast(message('Phone number updated'));
      navigate('/login');
    },
    onError: err => {
      const msg = axios.isAxiosError(err) && err.response?.data?.error;
      toast.danger(msg || 'There was an issue. Please try again.');
    },
  });
}

function verifyMobileOtp(payload: ForgotPhoneNumberVerifyMobileOtpPayload) {
  return apiClient
    .post('forgot-phone-number/verify-mobile-otp', payload)
    .then(response => response.data);
}
